/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "bplzldgfocajlxrgvyzw"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJwbHpsZGdmb2Nhamx4cmd2eXp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxOTk1NTksImV4cCI6MjA4Nzc3NTU1OX0._dHZcxSnnnbfWruxmUPkgNZosRbWM2ZeHUAVxVu5XUA"